import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('customer-groups', options)



// WEBPACK FOOTER //
// ./src/store/modules/customer-groups.js